import { useCallback, useState } from 'react'

export type UseDisclosureCallbacks = {
  onOpen?: () => void
  onClose?: () => void
}
export type UseDisclosureHandler = {
  close: () => void
  open: () => void
  toggle: () => void
}

export type UseDisclosureReturn = readonly [boolean, UseDisclosureHandler]

export const useDisclosure = (initialState = false, callbacks?: UseDisclosureCallbacks): UseDisclosureReturn => {
  const { onOpen, onClose } = callbacks || {}
  const [opened, setOpened] = useState(initialState)

  const open = useCallback(
    () =>
      setOpened((isOpened) => {
        if (!isOpened) {
          onOpen?.()
          return true
        }
        return isOpened
      }),
    [onOpen]
  )

  const close = useCallback(
    () =>
      setOpened((isOpened) => {
        if (isOpened) {
          onClose?.()
          return false
        }
        return isOpened
      }),
    [onClose]
  )

  const toggle = useCallback(
    () =>
      setOpened((isOpened) => {
        if (isOpened) {
          onClose?.()
        } else {
          onOpen?.()
        }

        return !isOpened
      }),
    [onClose, onOpen]
  )

  return [opened, { open, close, toggle }]
}
